export default __webpack_public_path__ + "static/media/emailSignupIcon.fa0f1720.svg";